import { getCookie } from '@/uptk/core/library/utils/cookies';

// isBrowser is true when window exists (browser or SSR with shims).
// isServerClient skips localStorage/DOM reads even when shims are present.
const isBrowser = typeof window !== 'undefined';
const isServerSide = typeof process !== 'undefined' && process.versions?.node;

const workspaceId = isServerSide ? 'default' : (localStorage.getItem('workspaceId') || 'default');

function getLocale() {
  if (isServerSide) return 'en';

  let language = localStorage.getItem('locale')
  if (language == undefined || language == null || language.trim() == "") {
     language = navigator.language.split(/[-_]/)[0];  // language without region code
      if (language !== 'fr' && language !== 'en' && language !== 'ar') {
        language = 'en'
      }
  }
  return language;
}

/*
 * Default value for redux store
 * note: locale is limited to en for now, multi langue needs to complete translation
 */
export default {
  selectedTheme: null,
  // theme: {},
  // theme: getCookie("theme") != undefined && getCookie("theme") != ""  ? createToolkitTheme(getCookie("theme")) : createToolkitTheme(document.documentElement.className),
  theme: isServerSide ? '' : (localStorage.getItem('theme') || document.documentElement.className),
  locale: getLocale(),
  selectedLocale: ['fr'], // getCookie("locale") != undefined && getCookie("locale") != ""  ? getCookie("locale") : getLocale(),
  locales: ['en', 'fr', 'de', 'it', 'ar'], // full supported set incl. ar (RTL showcase)
  workspaceId: workspaceId || 'DEV',
  selectedworkspaceId: isServerSide ? 'default' : (localStorage.getItem('workspaceId') || 'default'),
  selectedFeatures: isServerSide ? 'FEATURES' : (localStorage.getItem('selectedFeatures') || 'FEATURES'), // FEATURES, FEATURES_PREVIEW
  workspaceIds: ['1'], // TODO Should be dynamically loaded from back-end
  // selectedworkspaceId: 'DEMO',
  role: isServerSide ? 'users' : (localStorage.getItem('role') || 'users'),
  roles: [],
  selectedRole: isServerSide ? 'users' : (localStorage.getItem('selectedRole') || 'users'),
  year: isServerSide ? new Date().getFullYear().toString() : (localStorage.getItem('year') || new Date().getFullYear().toString()),
  years: [
    (new Date().getFullYear()-10).toString(),
    (new Date().getFullYear()-9).toString(),
    (new Date().getFullYear()-8).toString(),
    (new Date().getFullYear()-7).toString(),
    (new Date().getFullYear()-6).toString(),
    (new Date().getFullYear()-5).toString(),
    (new Date().getFullYear()-4).toString(),
    (new Date().getFullYear()-3).toString(),
    (new Date().getFullYear()-2).toString(),
    (new Date().getFullYear()-1).toString(),
    (new Date().getFullYear()  ).toString(),
    (new Date().getFullYear()+1).toString(),
    (new Date().getFullYear()+2).toString(),
    (new Date().getFullYear()+3).toString(),
    (new Date().getFullYear()+4).toString()
  ],
  selectedYear: isServerSide ? [new Date().getFullYear().toString()] : (localStorage.getItem('year') ? [localStorage.getItem('year')] : [new Date().getFullYear().toString()]),
  selectedBusinessIds: [],
  businessId: "",
  businessIds: [],
  suppliers: [],
  selectedSuppliers: ['*ALL'],
  selectedRbs: ['*ALL'],
  budgetrefs: [],
  invoicerefs: [],
  selectedInvoicerefs: ['*ALL'],
  selectedBudgetrefs: ['*ALL'],
  selectedBudgets: ['*ALL'],
  budgettypes: ['*ALL', 'Project', 'Budget', 'Envelop', 'Template'],
  selectedBudgettypes: ['*ALL'],
  selectedInvoicetypes: ['*ALL'],
  accounttypes: ['*ALL', 'Invest', 'Charges'],
  selectedAccounttypes: ['*ALL'],
  dftypes: ['*ALL', 'DFA', 'DFC', 'DFHB', 'DFRS', 'DFNC', 'TRANSIT'],
  selectedDftypes: ['*ALL'],
  cadomains: ['*ALL'],
  caids: ['*ALL'],
  selectedCaids: ['*ALL'],
  selectedCadomains: ['*ALL'],
  selectedYears: ['*ALL'],
  selectedServicetypes: ['*ALL'],
  selectedRd1s: ['*ALL'],
  selectedRd2s: ['*ALL'],
  selectedProjectleaders: ['*ALL'],
  selectedFlags: ['*ALL'],
  selectedFeature: 'FEATURES', // FEATURES, FEATURES_PREVIEW
  selectedCdstatuss: ['*ALL'],
  rbs: [],
  headofdivisions: [],
  servicetypes: [],
  rd1s: [],
  rd2s: [],
  projectleaders: [],
  flags: [],
  cdstatuss: [],
  sealId: "",
  sealIds: [],
  seals: [],
  supplier: [],
  supplierContent: [],
  selectedSealIds: [],
  data: [],
  contentData: [],
  dataRow: [],
  verum: [],
  verumpkg: [],
  verumdbi: [],
  verumstorage: [],
  verumbcm: [],
  verummiddleware: [],
  verumContent: [],
  verumdbiContent: [],
  verumpkgContent: [],
  verumstorageContent: [],
  dfs: [],
  selectedDfs: ['*ALL'],
  sla: [],
  slaContent: [],
  module: [],
  moduleContent: [],
  budget: [],
  reclassify: [],
  budgetContent: [],
  budgetconsumption: [],
  budgetconsumptionContent: [],
  supplierconsumption: [],
  supplierconsumptionContent: [],
  reclassifyContent: [],
  totalbyaccount: [],
  totalbyaccountContent: [],
  auditlog: [],
  auditlogContent: [],
  budgetline: [],
  budgetlineContent: [],
  xrfbudgetpsfline: [],
  xrfbudgetpsflineContent: [],
  budgetlineForm: {},
  budgetlinedetail: [],
  budgetlinedetailContent: [],
  budgetlinedetailForm: {},
  budgetrequest: [],
  budgetrequestContent: [],
  budgetrequestextra: [],
  budgetrequestextraContent: [],
  project: [],
  projectContent: [],
  projectreporting: [],
  projectreportingContent: [],
  glaccount: [],
  glaccountContent: [], 
  ca: [],
  caContent: [],
  invoice: [],
  invoiceContent: [],
  invoiceline: [],
  invoicelineContent: [],
  invoicelinedetail: [],
  invoicelinedetailContent: [],
  fileloading: [],
  fileloadingContent: [],
  fileexport: [],
  fileexportContent: [],
  contract: [],
  contractContent: [],
  order: [],
  orderContent: [],
  psf: [],
  psfContent: [],
  psfline: [],
  psflineContent: [],
  servicetype: [],
  servicetypeContent: [],
  application: [],
  applicationContent: [],
  test: [],
  testContent: [],
  team: [],
  teamContent: [],
  business: [],
  businessContent: [],
  bcm: [],
  bcmContent: [],
  filtersData: [],
  selectedGridRow: {},
  maxId: 0,
  parameter: [],
  parameterContent: [],
  isAuth: false,
  account: null,
  profile: {
    photo: null,
    self: null,
    accessToken: null
  },
  apiToken: null,
  pdf: null,
  searchText: '',
  approvalrequest: [],
  approvalrequestContent: [],
  moduleEntitlements: {
    // 'as const' keeps the literal type ('idle') so the object stays assignable
    // to ModuleEntitlementsState['status'] ('idle' | 'loading' | 'loaded' | 'error')
    status: 'idle' as const,
    tenantId: null,
    updatedAt: null,
    entitlements: {},
    error: null,
  },
}
